import customAxios from '../../customAxios';

import { COMPANY_PRICE_FACTORS_IS_NEED_PAY_2_COMPANY } from '../../routes';

const priceFactorsIsNeedpay2Company = async () => {
  try {
    return (await customAxios.get(COMPANY_PRICE_FACTORS_IS_NEED_PAY_2_COMPANY)).data;
  } catch (error: any) {
    console.log({ COMPANY_PRICE_FACTORS_IS_NEED_PAY_2_COMPANY: error });
  }
};

export default priceFactorsIsNeedpay2Company;
